import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { IAssessmentState } from '../store/assessment.types'
import { getAssessmentSelector } from '../selectors'
import { AssessmentConstants } from '../store/assessment.constant'

export function* setProcedureComplications() {
  try {
    const procedureState: IProcedureState = yield select(getProcedureStateSelector)
    const assessmentState: IAssessmentState = yield select(getAssessmentSelector)
    const { inputRows } = procedureState
    const { procedureComplications } = assessmentState
    inputRows.forEach((row) =>
      row.inputs.forEach((input) => {
        if (input.key === AssessmentConstants.SET_PROCEDURE_COMPLICATIONS) {
          //@ts-ignore
          input.props.savedValues = procedureComplications
        }
      })
    )
    yield put(setInputRows(inputRows))
  } catch (e) {
    yield put(throwPcrException(`setProcedureComplicationsSaga() error: ${e}`))
  }
}
export function* setProcedureComplicationsSaga() {
  yield takeLatest([AssessmentConstants.SET_PROCEDURE_COMPLICATIONS], performWithMutexHOG, setProcedureComplications)
}
